// redirects to homepage
import Config from 'config';

export const redirectToHome = () => {
  window.location.href = `${Config.api.host}`;
  return null;
};

export const redirectToManage = eventUrl => {
  window.location.href = `${eventUrl}/edit`;
  return null;
};

export const redirectToHostEventInfoBasics = () => {
  window.location.href = `basics`;
  return null;
};

export const redirectToLoginWithRedirectAfter = redirect => {
  if (window.location.search) {
    window.location.href = `${Config.api.host}/sign-up${window.location.search}&redirectTo=${redirect}`;
  } else {
    window.location.href = `${Config.api.host}/sign-in?redirectTo=${redirect}`;
  }
  return null;
};
